import moment from "moment";

export const statusColor = (status) => {
  if (status) {
    return "active-btn";
  } else {
    return "inactive-btn";
  }
};

export const changeMonthFormat = (date) => moment(date).format("MM");
export const changeYearFormat = (date) => moment(date).format("YYYY");

export const timeFormatOnly = (val) => {
  if (val) {
    const utcTime = moment.utc(val, ['DD-MM-YYYY HH:mm:ss', 'YYYY-MM-DD HH:mm:ss']);
    // const singaporeTime = utcTime.clone().utcOffset('+08:00');
    const formattedTime = utcTime.format('HH:mm:ss');
    return formattedTime;
  }
}

//image type for aws service
export const profile_image_type = 1;

export const MIN_PASSWORD_LENGTH = 8;

const PASSWORD_REQUIREMENTS = [
  { test: (value) => value.length >= MIN_PASSWORD_LENGTH, label: `at least ${MIN_PASSWORD_LENGTH} characters` },
  { test: (value) => /[A-Z]/.test(value), label: "an uppercase letter" },
  { test: (value) => /[a-z]/.test(value), label: "a lowercase letter" },
  { test: (value) => /\d/.test(value), label: "a number" },
  { test: (value) => /[^A-Za-z0-9\s]/.test(value), label: "a special character" },
];

/**
 * Strong password rule for an antd Form.Item, shared by every screen that sets a password.
 * It names every requirement still missing rather than only the first, so a user is not
 * sent round the form once per rule. An empty value passes -- add `required` separately
 * where the field is mandatory, so My Profile can still be left blank.
 */
export const strongPasswordRule = {
  validator(_, value) {
    if (!value) {
      return Promise.resolve();
    }
    const missing = PASSWORD_REQUIREMENTS.filter((requirement) => !requirement.test(value));
    if (missing.length === 0) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(`Password needs ${missing.map((requirement) => requirement.label).join(", ")}.`));
  },
};
//report types for employee
/**
 * Listing page size.
 *
 * The screens defaulted to 10 rows, which left most of the page empty and put
 * a 60-row result across six pages. 25 fills a normal screen without making the
 * request heavy. The configuration screens already used 50 and keep it.
 */
export const DEFAULT_PAGE_SIZE = 25;

/**
 * Options for the rows-per-page control. It used to be hidden unless a result
 * exceeded 100 rows, so on smaller results there was no way to see more than
 * the first 10 -- it is always available now.
 */
export const PAGE_SIZE_OPTIONS = ["10", "25", "50", "100"];

/**
 * The dashboard's attendance card is a preview, not a listing, so it stays
 * short -- a 25-row table there would push the cards above it off screen.
 */
export const DASHBOARD_PREVIEW_PAGE_SIZE = 10;

export const attendance_type = 1;
export const absentee_type = 2;

//reason types for unauthorised employee
export const calculateEightHoursAgo = (givenTime) => {
  if (givenTime) {
    const dateParts = givenTime.split(/[- :]/);
    const givenDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0], dateParts[3], dateParts[4], dateParts[5]);
    const currentDate = new Date();
    const differenceInSeconds = Math.floor((currentDate - givenDate) / 1000);
    if (differenceInSeconds < 28800) { // 8 hours = 28800 seconds
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const formatLastDetected = (givenTime) => {
  if (!givenTime) return null;
  const given = moment.utc(givenTime).utcOffset('+08:00');
  if (!given.isValid()) return null;
  const formatted = given.format('DD-MM-YYYY HH:mm');
  const now = moment();
  let diff = Math.max(0, now.diff(given, 'seconds'));
  const days = Math.floor(diff / 86400); diff -= days * 86400;
  const hours = Math.floor(diff / 3600); diff -= hours * 3600;
  const minutes = Math.floor(diff / 60);
  const parts = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  parts.push(`${minutes}m`);
  return `${formatted} (${parts.join(' ')} ago)`;
};
